import { ReactNode } from 'react';
import { Card } from './Card';

interface ChartCardProps {
  title: string;
  children: ReactNode;
  description?: string;
  filters?: ReactNode;
  maxHeight?: string;
}

export function ChartCard({ 
  title, 
  children, 
  description, 
  filters,
  maxHeight = '300px' 
}: ChartCardProps) {
  return (
    <Card>
      <div className="flex flex-col h-full">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
            {description && (
              <p className="text-sm text-gray-500 mt-1">{description}</p>
            )}
          </div>
          {filters && (
            <div className="flex items-center gap-2">
              {filters}
            </div>
          )}
        </div>
        <div 
          className="overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 pr-2" 
          style={{ maxHeight }}
        >
          {children}
        </div>
      </div>
    </Card>
  );
} 